
import React from 'react'

function ClockSvg() {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2897_96482)">
        <path d="M11.8845 21.4375C16.8075 21.4375 20.7983 17.4081 20.7983 12.4375C20.7983 7.46694 16.8075 3.4375 11.8845 3.4375C6.96156 3.4375 2.9707 7.46694 2.9707 12.4375C2.9707 17.4081 6.96156 21.4375 11.8845 21.4375Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.8848 7.4375V12.4375L14.856 15.4375" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2897_96482">
          <rect width="23.7702" height="24" fill="white" transform="translate(0 0.4375)" />
        </clipPath>
      </defs>
    </svg>


  )
}

export default ClockSvg